import { render } from "./CongresVue.vue?vue&type=template&id=511ee51e"
import script from "./CongresVue.vue?vue&type=script&lang=js"
export * from "./CongresVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__